var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.912 15.068c-1.276-.119-2.35-1.052-2.526-2.322A32.703 32.703 0 0 1 1.4 3.604c.172-1.187 1.14-2.082 2.332-2.207A60.174 60.174 0 0 1 10 1.07c2.145 0 4.211.121 6.226.33 1.212.125 2.197 1.039 2.369 2.245a32.74 32.74 0 0 1 .334 4.616c0 1.565-.133 3.087-.342 4.565a2.695 2.695 0 0 1-2.409 2.293 60.957 60.957 0 0 1-6.178.332h-.152c-1.499 1.723-2.648 2.575-4.656 3.477v-3.742l-.97-.09-.31-.029Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 8.897c0-.48.391-.774 1.08-1.235.64-.427.977-.981.827-1.735A1.98 1.98 0 0 0 10.38 4.4c-1.184-.235-2.323.7-2.323 1.906M10 12.223v-.357"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "question_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgQuestion;